import { isEmpty } from 'lodash';
import { getRawScriptList } from 'export-selector/selectors';
import { processScriptListForExportOptions } from 'export-selector/processors';

import { resourceType } from 'constants/loading';
import { isResourceTypeLoaded } from 'loading/selectors';
import { areScriptsLoadImprovementsEnabled } from 'user/selectors';
import { findScriptsForActiveOperation } from 'scripts/finders';

export const findExportOptions = async ({ dispatch, getState }) => {
  const state = getState();

  if (areScriptsLoadImprovementsEnabled(state)) {
    await findScriptsForActiveOperation({ dispatch, getState });
  }

  const rawList = getRawScriptList(getState());
  if (isEmpty(rawList)) {
    return [];
  }

  const areDevicesLoaded = isResourceTypeLoaded({ state: getState(), type: resourceType.DEVICE_LIST });
  const areAffiliatesLoaded = isResourceTypeLoaded({ state: getState(), type: resourceType.AFFILIATE_LIST });
  if (!areDevicesLoaded || !areAffiliatesLoaded) {
    return [];
  }

  return processScriptListForExportOptions({ dispatch, getState, rawList });
};
